import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, useRequestListagem } from 'hooks/useRequestListagem';
import { CondicaoPagamento } from 'pages/complementar/condicao-pagamento/types';
import { ConfigPedidoCondicoesPagamento } from 'pages/compra/configuracao-pedido/types';

export function useQueryCondicoesPagamentoLoja({ configPedidoCondicoesPagamento }: { configPedidoCondicoesPagamento: ConfigPedidoCondicoesPagamento }) {
    const requestListagem = useRequestListagem();
    const { sort, page, limit } = useListagemContext();

    return useQuery<RequestListagem<CondicaoPagamento[]>>({
        queryKey: ['config-pedido-condicoes-pagamento-loja', configPedidoCondicoesPagamento, sort, page, limit],
        queryFn: () =>
            requestListagem({
                page,
                limit,
                nested: true,
                url: '/gestao/condicaopagamento',
                sort: sort?.length ? sort : [{ property: 'idCondicaoPagamento', direction: 'ASC' }],
                filter: [
                    { property: 'fgAtivo', value: true, operator: 'eq' },
                    {
                        property: 'idGatewayPagamento',
                        operator: 'in',
                        value: configPedidoCondicoesPagamento.gatewayPagamento.map((item) => item.idGatewayPagamento),
                    },
                    {
                        property: 'idCondicaoPagamento',
                        value: configPedidoCondicoesPagamento.condicaoPagamentoGeral.map((item) => item.idCondicaoPagamento),
                        operator: 'neq',
                    },
                ],
            }).then((res) => res.data),
    });
}
